import { useEffect, useState, useCallback } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";

import styles from "./Footer.module.css"
import mylo_logo_yellow from "../../assets/images/logo_yellow.svg";


const Footer = () => {
	const handleNavigate = (loc) => {
		window.location = `${loc}`
	}

	return (
		<div className={styles.background}>
			<div className={styles.transition_container} style={{ top: '-80px' }}>
				<div className={styles.transition_effect_1} style={{ top: '50px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#000000" }}/>
				<div className={styles.transition_effect_2} style={{ top: '20px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#000000" }}/>
				<div className={styles.transition_effect_3} style={{ top: '-10px', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', background: "#000000" }}/>
			</div>

			<div className={styles.inner_background}>
				<div className={styles.footer_header}>
					<img src={mylo_logo_yellow}/>

					<a className={styles.banner_btn} href={"tel:+136956"}>
						<p className={`m2 inter medium`}>13 MYLO (13 69 56)</p>
						<i className="fa-solid fa-phone m3"></i>
					</a>
				</div>

				<div className={styles.footer_grid}>
					<div className={`${styles.footer_item} ${styles.footer_item_border}`}>
						<p className={`${styles.footer_item_header} m3 forma bold`}>Services</p>

						<div className={styles.footer_item_links}>
							<button onClick={() => handleNavigate("/safety")}><p className={`m2 inter light`}>MYLO Safe</p></button>
							<button><p className={`m2 inter light`}>MYLO Tradies</p></button>
							<button onClick={() => handleNavigate("/home-modifications")}><p className={`m2 inter light`}>MYLO Home Modifications</p></button>
						</div>
					</div>

					<div className={`${styles.footer_item} ${styles.footer_item_border} ${styles.footer_item_padding}`}>
						<p className={`${styles.footer_item_header} m3 forma bold`}>MYLO</p>

						<div className={styles.footer_item_links}>
							{/* <p className={`m2 inter light`}>About Us</p> */}
							<button onClick={() => handleNavigate("/")}><p className={`m2 inter light`}>Home</p></button>
							<button onClick={() => handleNavigate("https://myloportal.com.au")}><p className={`m2 inter light`}>MYLO Portal</p></button>
							{/* <p className={`m2 inter light`}>Work With Us</p> */}
							<button onClick={() => handleNavigate("/contact")}><p className={`m2 inter light`}>Contact Us</p></button>
						</div>
					</div>

					<div className={`${styles.footer_item} ${styles.footer_item_border} ${styles.footer_item_padding}`}>
						<p className={`${styles.footer_item_header} m3 forma bold`}>Connect</p>

						<div className={styles.footer_item_links}>
							<button onClick={() => handleNavigate("https://www.instagram.com/mylopropertysolutions_")}><p className={`m2 inter light`}>Instagram</p></button>
							<button onClick={() => handleNavigate("https://www.facebook.com/mylopropertysolutions/")}><p className={`m2 inter light`}>Facebook</p></button>
							<button onClick={() => handleNavigate("https://au.linkedin.com/company/mylo-services")}><p className={`m2 inter light`}>LinkedIn</p></button>
						</div>
					</div>

					<div className={`${styles.footer_item} ${styles.footer_item_border} ${styles.footer_item_padding}`}>
						<p className={`${styles.footer_item_header} m3 forma bold`}>Contact Us</p>

						<div className={styles.footer_item_links}>
							<a href={"tel:+136956"}><p className={`m2 inter light`}>13 MYLO (13 69 56)</p></a>
							<a href={"mailto:office@mylo.com.au"}><p className={`m2 inter light`}>office@mylo.com.au</p></a>
							<button onClick={() => handleNavigate("/contact")}><p className={`m2 inter light`}>Contact Us</p></button>
						</div>
					</div>

					<div className={`${styles.footer_item} ${styles.footer_item_padding}`}>
						<p className={`${styles.footer_item_header} m3 forma bold`}>Find Us</p>

						<div className={styles.footer_item_links}>
							<p className={`m2 inter light`}>Level 1, 469-479 Glen Huntly Road Elsternwick VIC 3185</p>
							<p className={`m2 inter light`}>Tower 2, 1705/101 Grafton St Bondi Junction NSW 2022</p>
						</div>
					</div>
				</div>

				<p className={`s3 inter light ${styles.mylo_trademark}`}>© MYLO 2025</p>
			</div>	
		</div>
	)
};

export default Footer;